import { Typography } from '@mui/material'
const HelpText = () => <div className='p-5'><Typography variant='h4'>Unarchive template</Typography><p>Unarchiving restores an archived template to the active list. It can then be edited, used to issue passes and selected elsewhere in Studio.</p></div>
export default HelpText
